export const SET_NAV_ITEMS = 'SET_NAV_ITEMS'
